import React from 'react';
import ReactECharts from 'echarts-for-react';

const BarChart = ({graphData}) => {
  const option = {
    tooltip: {
      trigger: 'axis', // or 'item' depending on your use case
      axisPointer: {
        type: 'line', // 'line', 'shadow', 'cross', etc.
      },
    },
    grid: {
      left: '30', // Adjust grid margins as needed
      right: '30',
      top: '5%',
      bottom: '10%',
    },
    xAxis: {
      type: 'category',
      data: graphData.map(e=>e.label),
      axisLabel: {
        fontWeight: 'bold',  // Make the x-axis labels bold
        color: '#000000'
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        fontWeight: 'bold',
        color: '#000000'  // Make the y-axis labels bold
      },
    },
    series: [
      {
        data: graphData.map(e=>e.customer_count),
        type: 'bar',
        // barWidth: 35,
        showBackground: true,
        backgroundStyle: {
          color: 'rgba(180, 180, 180, 0.2)',  // Background color of bars
        },
        itemStyle: {
          color: '#F29F67',  // Set the bar color to #F29F67
        },
      },

       
    ],
  };


  return <ReactECharts option={option} style={{ height: 400, width: '100%' }} />;
};

export default BarChart;
